
import { getColorType } from "PDF/helpers/documentStyle";

import { INodeData } from "./types";

import blueStyles from "./blueColor.module.scss";
import blueGreenStyles from "./blueGreenColor.module.scss";
import blueRedStyles from "./blueRedColor.module.scss";
import blueYellowStyles from "./blueYellowColor.module.scss";
import greenStyles from "./greenColor.module.scss";
import redStyles from "./redColor.module.scss";

const styles = {
  green: greenStyles,
  red: redStyles,
  blue: blueStyles,
  blueGreen: blueGreenStyles,
  blueRed: blueRedStyles,
  blueYellow: blueYellowStyles,
};

export const prepareDataSource = (data: INodeData) => {
  if (data.children && data.isLast) {
    data._children = data.children;
    data.children = [];
  } else if (data.children) {
    data.children = data.children.map((child) =>
      prepareDataSource(child)
    );
  }
  return data;
}

export const getStyles = () => styles[getColorType()];